export default {
  driver_performance_driver_title: "Rendimiento del Conductor - Conductor",
  driver_performance_driver_searchDriver: "Buscar por Conductor",
  driver_performance_driver_id: "ID",
  driver_performance_driver_driver: "Conductor",
  driver_performance_driver_avgEvents: "Evento de Riesgo Promedio",
  driver_performance_driver_RiskScore: "Puntuación de Riesgo",
  driver_performance_driver_stopVisited: "Paradas Visitadas",
  driver_performance_driver_riskEvents: "Eventos de Riesgo",
  driver_performance_driver_Events: "Eventos",
  driver_performance_driver_totalDistance: "Distancia Total",
  driver_performance_driver_Tags: "Etiquetas",
  driver_performance_driver_status_unassigned: "Sin Asignar",
  driver_performance_driver_lastCoaching: "Último Entrenamiento",
  driver_performance_driver_sendToCoaching: "Enviar a Entrenamiento",
  driver_performance_driver_shareDriver: "Compartir Conductor",
};
